import {
  FilterFilled,
  FilterOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { LuEraser } from "react-icons/lu";

import { Tooltip } from "@/ui/tooltip";

import { useListResetActions } from "./list-reset-actions.hook";

const i18Key = "global:listResetActions";

const ListResetActions = () => {
  const { t } = useTranslation();
  const { noFilterSort, resetButton, deleteButton } = useListResetActions();
  const title = t(`${i18Key}.title${noFilterSort ? "Without" : "With"}`);

  return (
    <Flex gap="small" align="center">
      {noFilterSort ? <FilterOutlined /> : <FilterFilled />}
      <Typography.Text>{title}</Typography.Text>
      <Tooltip title={t(`${i18Key}.resetButton`)}>
        <Button
          {...resetButton}
          icon={<ReloadOutlined />}
          data-testid="list-reset-button"
        />
      </Tooltip>
      <Tooltip title={t(`${i18Key}.deleteButton`)}>
        <Button
          {...deleteButton}
          icon={<LuEraser />}
          data-testid="list-delete-button"
        />
      </Tooltip>
    </Flex>
  );
};

export default ListResetActions;
